/**
 * OrbDocReferenceOperatorsENOrbDocReferenceOperatorsENPage
 *
 * Page component for OrbDocReferenceOperatorsENOrbDocReferenceOperatorsENPage
 * Path: /docs/reference/operators
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocReferenceOperatorsENDocScreenView as __OrbDocReferenceOperatorsENDocScreenView } from '@/components/traits/OrbDocReferenceOperatorsENDocScreenView';
import { OrbDocReferenceOperatorsENDocAnalyticsView as __OrbDocReferenceOperatorsENDocAnalyticsView } from '@/components/traits/OrbDocReferenceOperatorsENDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocReferenceOperatorsENOrbDocReferenceOperatorsENPageProps {
  // Add any page-level props here
}

export function OrbDocReferenceOperatorsENOrbDocReferenceOperatorsENPage(_props: OrbDocReferenceOperatorsENOrbDocReferenceOperatorsENPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"Operators","description":"Every operator a .lolo program can call, from the canonical registry the compiler bakes.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/reference/operators"},{"locale":"ar","path":"/ar/docs/reference/operators"},{"locale":"sl","path":"/sl/docs/reference/operators"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocReferenceOperatorsENDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocReferenceOperatorsENDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocReferenceOperatorsENOrbDocReferenceOperatorsENPage;
